import React from 'react'
import './styles/main.sass'
import HomePage from './pages/HomePage'

const App: React.FC = () => {
    return <HomePage />
}

export default App
